import { Boolean, Number, Partial, Static, String } from "runtypes";

export const UserRunType = Partial({
  email: String,
  id: Number,
  isAdmin: Boolean,
  isDirector: Boolean,
  isVerify:Boolean,
  videoCount:Number,
  status:Boolean,
  firstName:String,
  lastName:String
  ,is_mask_student_name: Boolean
});
export const UserEmailType = Partial({
  email: String,
});

export interface IUser extends Static<typeof UserRunType> {
  restrictedCoaches?: number[] | null;
  coachId?: number;
  coachEditId?: number;
  is_mask_student_name?: boolean;
}



// WEBPACK FOOTER //
// ./src/api/types/IUser.ts